import { render } from "./ContentCustomizing.vue?vue&type=template&id=afcaf660&ts=true"
import script from "./ContentCustomizing.vue?vue&type=script&lang=ts"
export * from "./ContentCustomizing.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__